export default __webpack_public_path__ + "static/media/workflow-icon.6b14fdbd.svg";